import {
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import { Button, Divider } from "@mui/material";
import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
// import { PrintEtat } from "./Etat/print";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";

export interface IDialogAlerteProps {
  title?: string;
  dialogContent: any;
  open: boolean;
  handleClose?: any;
  actionFunction?: any;
  addLoading?: boolean;
  iconeSauveButton: any;
  actionLabel?: string;
}

export default function DialogUrne(props: IDialogAlerteProps) {
  const {
    dialogContent,
    open,
    handleClose,
    actionFunction,
    addLoading,
    title,
    iconeSauveButton,
    actionLabel
  } = props;

  const { arrayGagnantToPrint } = useSelector((state: IReduxState) => state.focusEcole);

  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true} open={open}
    >
      <div
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <DialogTitle id="alert-dialog-title">
          {title ? title : "Alerte!"}
        </DialogTitle>
        <DialogTitle
          // style={{ marginTop: 10 }}
        >
          {arrayGagnantToPrint.length > 0 && ""}
          {/* {arrayGagnantToPrint.length > 0 && <PrintEtat />} */}
        </DialogTitle>
      </div>
      <Divider />
      <DialogContent
        style={{ height: "60vh" }}
      >
        {dialogContent}
      </DialogContent>
      <DialogActions style={{ marginRight: 15, marginBottom: 10 }}>
        <Button color="error" onClick={handleClose}>
          Annuler
        </Button>
        
        <LoadingButton
          loadingPosition="end"
          loading={addLoading}
          endIcon={iconeSauveButton}
          size="small"
          variant="contained"
          onClick={actionFunction}
        >
          {actionLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
